import {
    Button,
    Grid,
    Typography
}                        from "@mui/material";
import React, {
    useEffect,
    useRef
}                        from "react";
import {
    AddCompany,
    Company,
    IGStyle,
}                        from "../../constants";
import {useGobesContext} from "../../context/GobesContextProvider";
import {
    getCompanyRecordSystem,
}                        from "../../util";

const SearchableCompanyBlock = () =>
{
    const {
        activePage, setActivePage,
        setCompanyDetails, setSubPage,
        setFormData, setSelectedCompanyRecord,
        setModalVisible,
        setModalAction,
        refreshResource, setRefreshResource,
    } = useGobesContext()

    const RMRef = useRef<any>()

    useEffect(() =>
    {
        RMRef.current?.addEventListener('recordSelected', (event: any) =>
        {
            setActivePage(1)
            setSubPage(0)
            console.log(event.detail.record)
            setCompanyDetails(event.detail.record)
            setSelectedCompanyRecord(`aggregateInstanceId =="` + event.detail.recordId + "\"")
            // getCompanyRecordSystem(event.detail.recordId).then(async (data: any) =>
            //     {
            //         const Data = await data.json()
            //         //setActivePage(1)
            //         //setSubPage(0)
            //         //setCompanyDetails(Data)
            //         //setSelectedCompanyRecord(`aggregateInstanceId =="` + event.detail.recordId + "\"")
            //     }
            // )
        })
    }, [])

    useEffect(() =>
    {
        switch (refreshResource)
        {
            case Company:
                setTimeout(() => RMRef.current?.refresh(), 1000)
                break
        }
        setRefreshResource("")
    }, [refreshResource]);

    function AddObject()
    {
        setFormData(undefined)
        setCompanyDetails(undefined)

        setModalVisible(true)
        setModalAction(AddCompany)
    }

    return (<>
        <Grid container justifyContent="center" direction={"column"}>
            <Grid container className={"rm-container"} direction={"row"} display={activePage === 0
                                                                                  ? "flex"
                                                                                  : "none"}>
                <Grid container>
                    <Typography variant="h4" marginRight={"auto"}>
                        Bedrijven
                    </Typography>
                </Grid>

                <Grid item xs={8} container alignItems={"stretch"} className={"containerspacing"}>
                    {/*// @ts-ignore*/}
                    <ig-resource-master lang="nl-NL" style={IGStyle} ref={RMRef} class={"ig-columns"} searchable-resource-master-id="SearchableCompanyRM"/>
                </Grid>

                <Grid container item className={"button-container"} xs={3} marginLeft={1} justifyContent={"flex-start"}>

                    <Grid item xs={4}>
                        <Grid container direction="column" item>
                            <Button variant={"contained"} onClick={AddObject}>Bedrijf Toevoegen</Button>
                        </Grid>
                    </Grid>

                </Grid>

            </Grid>
        </Grid>
    </>)
}

export default SearchableCompanyBlock